import type { FlexProps } from './Flex.types';

export const getFlexUtility = (props?: FlexProps): string => {
  if (!props) return 'flex';

  const flexClasses: Set<string> = new Set<string>();
  const flexBase: 'flex' | 'inline-flex' = props?.isInline
    ? 'inline-flex'
    : 'flex';

  flexClasses.add(flexBase);

  if (props.isStretch) flexClasses.add('align-stretch');
  if (props.takeAvailableSpace) flexClasses.add('flex-1');
  if (props.isCentered) flexClasses.add('flex-center');
  if (props.isColumn && !props.isRow) flexClasses.add('flex-column');
  if (props.isWrapping) flexClasses.add('flex-wrap');
  if (props.isYCentered) flexClasses.add('flex-y-center');
  if (props.isXCentered) flexClasses.add('flex-x-center');
  if (props.yAlign === 'baseline') flexClasses.add('align-baseline');
  if (props.yAlign === 'start') flexClasses.add('align-flex-start');
  if (props.yAlign === 'end') flexClasses.add('align-flex-end');
  if (props.xAlign === 'start') flexClasses.add('justify-flex-start');
  if (props.xAlign === 'end') flexClasses.add('justify-flex-end');
  if (props.xAlign === 'center') flexClasses.add('flex-x-center');
  if (props.isBetween) flexClasses.add('space-between');
  if (props.isAround) flexClasses.add('space-around');
  if (props.onClick) flexClasses.add('cursor-pointer');
  if (props.isGrowing) flexClasses.add('grow-1');
  if (props.isFullWidth) flexClasses.add('wp-100');

  if (props.gap) flexClasses.add(`gap-${props.gap}`);
  if (props.padding) flexClasses.add(`p-${props.padding}`);
  if (props.paddingY) flexClasses.add(`py-${props.paddingY}`);
  if (props.paddingX) flexClasses.add(`px-${props.paddingX}`);

  if (props.responsive === 'mobile') flexClasses.add('flex-mobile');
  if (props.responsive === 'tablet') flexClasses.add('flex-tablet');
  if (props.responsive === 'desktop') flexClasses.add('flex-desktop');
  if (props.responsive === 'wide') flexClasses.add('flex-wide');

  if (props.backgroundColor === 'primary') flexClasses.add('bg-primary');
  if (props.backgroundColor === 'subtle') flexClasses.add('bg-primary-subtle');

  if (props.className) flexClasses.add(props.className);

  if (props.isFullHeight) flexClasses.add('flex-full-height');

  return Array.from(flexClasses).join(' ');
};

export const getSafeFlexProps = (props: any): Partial<FlexProps> => {
  const {
    backgroundColor,
    disablePadding,
    gap,
    header,
    headerButtons,
    headerIcon,
    headerLeft,
    isAround,
    isBetween,
    isCentered,
    isColumn,
    isColumnCentered,
    isFullHeight,
    isFullScreen,
    isFullWidth,
    isGrowing,
    isInline,
    isOverflowing,
    isRow,
    isStretch,
    isWrapping,
    isXCentered,
    isYCentered,
    maxHeight,
    maxWidth,
    padding,
    paddingX,
    paddingY,
    takeAvailableSpace,
    xAlign,
    yAlign,
    ...safeProps
  } = props;

  return safeProps;
};
